import React from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import s from './PriorityListDrawer.module.scss'

const PriorityListDrawer = ({ title, subtitle, items = [], renderItem, onClose }) => {
	const overlay = (
		<div className={s.overlay}>
			<div className={s.scrim} onClick={onClose} />
			<aside className={s.wrap} onClick={e => e.stopPropagation()}>
				<header className={s.header}>
					<div className={s.header__inner}>
						<h2 className={s.title}>{title}</h2>
						{subtitle ? <p className={s.meta}>{subtitle}</p> : null}
					</div>
					<button
						type="button"
						className={s.close}
						onClick={onClose}
						aria-label="Close list"
					>
						<CrossIcon />
					</button>
				</header>
				<div className={s.grid}>
					{items.map((item, idx) => (
						<React.Fragment key={item?.id ?? idx}>
							{renderItem(item, idx)}
						</React.Fragment>
					))}
				</div>
			</aside>
		</div>
	)

	return typeof document !== 'undefined'
		? createPortal(overlay, document.body)
		: overlay
}

export default PriorityListDrawer
